import React, { useEffect, useState } from "react";

const HighlightModal = ({
  isOpen,
  highlights,
  onClose,
  onDelete,
  book,
  chapter,
  verseNumber,
}) => {
  const [localHighlights, setLocalHighlights] = useState([]);
  const [isClosing, setIsClosing] = useState(false);

  // Sync local highlights with the initial highlights when modal opens
  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
      setLocalHighlights(highlights);
    }
  }, [isOpen, highlights]);

  // Handle delete and update the local list
  const handleDelete = (id) => {
    const updatedHighlights = localHighlights.filter(
      (highlight) => highlight.id !== id
    );
    setLocalHighlights(updatedHighlights);

    if (updatedHighlights.length === 0) {
      triggerClose();
    }
    onDelete(id);
  };

  // Trigger close animation
  const triggerClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // Match CSS transition duration
  };

  return (
    isOpen && (
      <div className="fixed inset-0 flex items-center justify-center z-50">
        {/* Backdrop */}
        <div
          className={`absolute inset-0 bg-black ${
            isClosing ? "opacity-0" : "opacity-50"
          } transition-opacity duration-300`}
        ></div>

        {/* Modal */}
        <div
          className={`bg-white rounded-lg shadow-lg p-6 z-50 relative w-96 max-w-full transform ${
            isClosing ? "scale-95 opacity-0" : "scale-100 opacity-100"
          } transition-all duration-300`}
        >
          <h2 className="text-xl font-semibold mb-4 text-center">
            Highlights - {book} {chapter}:{verseNumber % 1000}
          </h2>

          {/* Updated Highlight List */}
          <ul className="space-y-4 mb-6">
            {localHighlights.length > 0 ? (
              localHighlights.map((highlight) => (
                <li
                  key={highlight.id}
                  className="flex flex-col items-start space-y-2"
                >
                  <p className="text-gray-700 bg-gray-100 p-2 rounded-md w-full">
                    {highlight.selected_text}
                  </p>
                  <button
                    onClick={() => handleDelete(highlight.id)}
                    className="self-end text-red-500 hover:text-red-700 text-sm"
                  >
                    Delete
                  </button>
                </li>
              ))
            ) : (
              <p className="text-center text-gray-500">
                No highlights remaining.
              </p>
            )}
          </ul>

          {/* Action buttons */}
          <div className="flex justify-end mt-4">
            <button
              onClick={triggerClose}
              className="bg-[#983b10] hover:bg-[#7d2d07] text-black font-medium py-2 px-4 rounded w-1/2"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default HighlightModal;
